module.exports = __webpack_public_path__ + "img/MGH-Toyosu-2.3b37efd1.jpg";